import React from 'react'
import List from '../pages/list'

export const PagesLaLigaVSList = (props) => <List {...props} filter={{ collection: 'laligavs' }} title="Pages LALIGA VS" />

export default PagesLaLigaVSList
